import { Search } from "./getDefaultSearch";

export function validateSearch(search: Search) {
  if (search.composite_terms?.and && search.composite_terms.and.every((x) => x.or)) {
    return search;
  } else {
    throw "Invalid ownership search";
  }
}
